import {useEffect, useState} from 'react'
import useAuth from 'features/auth/useAuth'
import {fetchPackageListApi} from 'api/productApi'
import {TYPE_INDICATOR_PRODUCT} from 'pages/ProductsPages/constant'
import {PACKAGE_TYPE} from 'constants/AnalysisConstant'

function useProductList() {
  const [idOver20Product, setIdOver20Product] = useState<string[]>([])
  const {user: currentUser} = useAuth()

  const getDataProductList = async () => {
    try {
      const res = await fetchPackageListApi({
        target: TYPE_INDICATOR_PRODUCT.ALL,
      })
      if (res.data.length > 0) {
        const over20Product =
          res.data
            .filter(
              (item) =>
                item.type === PACKAGE_TYPE.AI_PREMIUM_PLUS ||
                item.type === PACKAGE_TYPE.AI_PREMIUM_PLUS_HRV,
            )
            .map((product) => String(product.itemId)) || []

        setIdOver20Product((prev) => {
          if (JSON.stringify(prev) !== JSON.stringify(over20Product)) {
            return over20Product
          }
          return prev
        })
      }
    } catch (error) {
      console.error('Failed to fetch product list', error)
    }
  }

  useEffect(() => {
    if (currentUser) {
      getDataProductList()
    }
  }, [currentUser])

  return {
    idOver20Product,
    getDataProductList,
  }
}

export default useProductList
